<template>
  <div ref="loginForm" class="login-form">
    <div class="logo" v-html="logo"></div>

    <form class="form" @submit.prevent="onFormSubmit">
      <div class="messages">
        <div class="message error" :class="{show:showMessage}">
          <i class="fa fa-times" @click="closeMessage()"></i>
          <i class="fa fa-exclamation-circle indicator"></i>
          <div class="message-inner">
            <span>{{ errorMessage }}</span>
          </div>
        </div>
        <div class="message info" :class="{show:showInfo}">
          <i class="fa fa-times" @click="closeMessage()"></i>
          <i class="fa fa-exclamation-circle indicator"></i>
          <div class="message-inner">
            <span>{{ errorMessage }}</span>
          </div>
        </div>
      </div>

      <div
        v-if="displayWarning"
        class="alert alert-warning mb-3"
        v-html="$t('general_warning')"
      ></div>

      <div class="form-row row">
        <i class="fa fa-user"></i>
        <input id="username" name="username" class="form-input col" type="text" v-model.lazy="user.login"
               :placeholder="placeholders.login"/>
      </div>
      <div class="form-row row">
        <i class="fa fa-lock"></i>
        <input id="password" name="password" class="form-input col" type="password" v-model.lazy="user.password"
               :placeholder="placeholders.password"/>
      </div>
      <div class="form-row row" v-if="devMode">
        <i class="fa fa-code"></i>

        <select v-model.lazy="api" class="form-input col">
          <option value="">Choisir une API</option>
          <option v-for="routeConfig in apiOptions" :key="routeConfig.index" :value="routeConfig.route">API de
            {{ routeConfig.label }}
          </option>
        </select>
      </div>
      <br>
      <br>
      <Btn id="connexion" :class="'default block'" :btnType="'submit'" @click.native.prevent="onFormSubmit">
        {{ $t('login.loginBtn') }}
      </Btn>
      <div class="login-separator">
        <hr>
        <span>{{ $t('global.or') }}</span>
      </div>
      <Btn :class="'google block'" :btnType="'button'" @click.native.prevent="onGoogleLogin">
        <div v-html="googleLogo"></div>
        {{ $t('login.googleLoginBtn') }}
      </Btn>
      <Btn :class="'microsoft block'" :btnType="'button'" @click.native.prevent="onMicrosoftLogin">
        <div v-html="microsoftLogo"></div>
        {{ $t('login.microsoftLoginBtn') }}
      </Btn>
      <input v-show="false" type="submit"/>
      <div class="center password-lost">
        <Btn id="lostPassword" :class="[{'force-hover':passwordLostShow}]" @click.native.prevent="onPasswordLost">
          {{ $t('login.passwordLost') }}
        </Btn>
        <div class="password-lost-popover" :class="{show:passwordLostShow}">
          <i class="fa fa-times" @click.prevent="closePasswordLost"></i>
          <p>{{ $t('login.explainPasswordLost') }}</p>
          <div class="form-row row">
            <div class="col">
              <i class="fa fa-user"></i>
              <input type="text" class="form-input" id="usernameForget" name="usernameForget"  v-model="loginForgetPassword"
                     :placeholder="placeholders.loginLostPassword"/>
            </div>
            <div class="col-2">
              <Btn :class="'icon pull-right'" @click.native="requestPasswordLost"><i
                class="fa fa-arrow-circle-right"></i></Btn>
            </div>
          </div>
        </div>
      </div>

    </form>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Auth from '@/services/auth.js'
import API from '@/services/API.js'
import Utils from '@/services/utils.js'
import Btn from '@/components/ui/Button'
import Toolbar from '@/components/ui/Toolbar'
import moment from 'moment';
import 'moment-timezone';

import src from '@/assets/img/logo2.svg';
import srcSFR from '@/assets/img/logo2-sfr.svg';

import _filter from 'lodash/filter'
import _find from 'lodash/find'
import _indexOf from 'lodash/indexOf'
import _map from 'lodash/map'
import _intersection from 'lodash/intersection'

import GoogleLogo from '@/assets/img/google-logo-sso.svg'
import MicrosoftLogo from '@/assets/img/logo-microsoft.svg'

export default {
  name: 'login',
  beforeCreate: function() {
    if (this.$route.params.token == null) {
      const baseUrl = Utils.getDevantBaseUrl();
      window.location.href = `${baseUrl}/login`
    }
  },
  computed: {
    googleLogo() {
      return GoogleLogo
    },
    microsoftLogo() {
      return MicrosoftLogo
    },
    logo() {
      if (this.theme == 'sfr') {
        return srcSFR
      }
      return src
    },
    theme() {
      return Utils.getThemeName()
    },
    devMode() {
      if (process.env.NODE_ENV == 'development') {
        return true
      }
      return false
    },
    loginForgetPassword() {
      return this.user.login
    }
  },
  components: {
    Btn,
    Toolbar
  },
  data: () => ({
    user: {
      login: '',
      password: '',
    },
    placeholders: {
      login: window.V.$i18n.t('login.login'),
      password: window.V.$i18n.t('login.password'),
      loginLostPassword: window.V.$i18n.t('login.loginLostPassword')
    },
    errorMessage: '',
    showMessage: false,
    showInfo: false,
    loginLostPassword: '',
    passwordLostShow: false,
    api: "",
    apiOptions: [],
    displayWarning: moment().isBefore(Utils.momentLocalised("2023-11-28 14:00:00"))
  }),

  methods: {
    onFormSubmit: function (evt) {
      var vThis = this;
      if (this.user.login != "" && this.user.password != "" && evt.currentTarget.id == 'connexion') {

        window.Vfc.$refs.loading.show();

        Auth.login(this.user.login, this.user.password, function (data) {

          var redirect = '/home';

          let possibleEntryPoints = _map(_filter(vThis.$router.options.routes, o => {
            if (o.meta) {
              return o.meta.permission
            }
            return false


          }), n => {
            return n.meta.permission
          })

          let entryPoints = _intersection(possibleEntryPoints, window.V.acl.permissions)


          let route = _find(vThis.$router.options.routes, o => {
            return o.meta.permission == entryPoints[0];
          })

          if (route) {
            redirect = route.path;
          }


          if (window.V._router.app._route.query.redirect) {
            if (window.V._router.app._route.query.redirect != '/logout') {
              redirect = window.V._router.app._route.query.redirect;
            }

          }

          window.V._router.replace(redirect);
          vThis.errorMessage = '';
          vThis.showMessage = false;
          window.V.loginMode = false;
        }, function (error) {
          if (window.loginError != '' && window.loginError != null) {
            vThis.errorMessage = window.V.$i18n.t("login.errors.passwords."+error.response.data.message)
            vThis.showMessage = true;
          } else {
            vThis.errorMessage = '';
            vThis.showMessage = false;
          }
          window.Vfc.$refs.loading.hide();
        });
      }
      else if (evt.currentTarget.id == 'connexion') {
        vThis.errorMessage = Utils.t('login.emptyLoginPassword');
        vThis.showMessage = true;
      }

    },

    onMicrosoftLogin() {

      var vThis = this;

      Auth.MicrosoftLogin(function (data) {

        var redirect = '/home';

        let possibleEntryPoints = _map(_filter(vThis.$router.options.routes, o => {
          if (o.meta) {
            return o.meta.permission
          }
          return false


        }), n => {
          return n.meta.permission
        })

        let entryPoints = _intersection(possibleEntryPoints, window.V.acl.permissions)

        let route = _find(vThis.$router.options.routes, o => {
          return o.meta.permission == entryPoints[0];
        })

        if (route) {
          redirect = route.path;
        }

        if (window.V._router.app._route.query.redirect) {
          if (window.V._router.app._route.query.redirect != '/logout') {
            redirect = window.V._router.app._route.query.redirect;
          }
        }

        window.V._router.replace(redirect);
        vThis.errorMessage = '';
        vThis.showMessage = false;
        window.V.loginMode = false;
      },function (error) {
          window.V._router.replace('/logout');
      })
    },

    onGoogleLogin() {
      var vThis = this;

      Vue.googleAuth().directAccess()

      Vue.googleAuth().signIn(googleUser => {

        window.Vfc.$refs.loading.show();

        let accessToken = this.getAccessToken(googleUser)

        Auth.googleLogin(accessToken, function (data) {


          var redirect = '/home';


          let possibleEntryPoints = _map(_filter(vThis.$router.options.routes, o => {
            if (o.meta) {
              return o.meta.permission
            }
            return false


          }), n => {
            return n.meta.permission
          })


          let entryPoints = _intersection(possibleEntryPoints, window.V.acl.permissions)


          let route = _find(vThis.$router.options.routes, o => {
            return o.meta.permission == entryPoints[0];
          })


          if (route) {
            redirect = route.path;
          }


          if (window.V._router.app._route.query.redirect) {
            if (window.V._router.app._route.query.redirect != '/logout') {
              redirect = window.V._router.app._route.query.redirect;
            }

          }


          window.V._router.replace(redirect);
          vThis.errorMessage = '';
          vThis.showMessage = false;
          window.V.loginMode = false;
        }, function (error) {
          if (window.loginError != '' && window.loginError != null) {
            vThis.errorMessage = window.loginError;
            vThis.showMessage = true;
          } else {
            vThis.errorMessage = '';
            vThis.showMessage = false;
          }
          window.Vfc.$refs.loading.hide();
        });

      }, function (error) {

      })
    },

    getAccessToken(data) {
      for (const value1 of Object.values(data)) {
        for (const value2 of Object.values(value1)) {
          if (value2.hasOwnProperty('access_token')) {
            return value2.access_token
          }
        }
        if (value1.hasOwnProperty('access_token')) {
          return value1.access_token
        }
      }
      return null
    },

    closeMessage: function (type) {
      this.showMessage = false;
      this.showInfo = false;
    },
    onPasswordLost: function (evt) {
      //this.login
      this.passwordLostShow = !this.passwordLostShow;
    },
    closePasswordLost: function (evt) {
      this.passwordLostShow = false;
    },
    requestPasswordLost: function () {
      axios.defaults.headers.app = 'beepiz-front';

      axios.defaults.baseURL = API.apiBaseURL;

      axios.post(API.route(API.endpoints.oauth.forget), {
        login: document.getElementById('usernameForget').value,
        universe: Utils.getThemeName() === 'sfr' ? 'sfr_beepiz' : 'beepiz'
      }).then(response => {
        this.errorMessage = response.data.message;
        this.showInfo = true
        this.closePasswordLost()
      }).catch(error => {
        console.log(error.response.data.message)
        if (error.response.data.message) {
          this.errorMessage = window.V.$i18n.t(error.response.data.message);
          this.showMessage = true;

        }
      })
    },
    parseDevRoutes: function () {
      const routesConfig = process.env.BASE_API_DEV_URL ?? '';
      routesConfig.split(',').forEach((routeConfig, index) => {
        const [label, route] = routeConfig.split(' ');
        this.apiOptions.push({index, label, route});
      })
    }
  },

  mounted() {
    window.V.loginMode = true;

    var userLang = navigator.language || navigator.userLanguage;

    if (this.$route.params.token == null) {
      window.Vfc.$refs.loading.hide();
    }

    if (this.devMode) {
      this.parseDevRoutes();
    }
  },
  beforeRouteUpdate(to, from, next) {

    if (window.loginError != '' && window.loginError != null) {
      this.errorMessage = window.loginError;
      this.showMessage = true;
    } else {
      this.errorMessage = '';
      this.showMessage = false;
    }

    if (to.params.token == null) {
      window.Vfc.$refs.loading.hide();
    }
    next();
  },

  watch: {
    api(newVal, oldVal) {
      if (newVal !== "") {
        if (process.env.NODE_ENV === 'development') {
          localStorage.setItem('dev_api', newVal);
        }
        API.apiBaseURL = newVal
      } else {
        API.apiBaseURL = process.env.BASE_API_URL;
      }

    }
  }
}
</script>

<style lang="scss">


</style>
